const Vue = require('vue');
const EventBus = new Vue();

export default EventBus;



// WEBPACK FOOTER //
// ./resources/assets/js/eventbus.js